<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Óbitos"
            description="Cidadãos com óbito informado no cadastro"
            url="/gestao-cadastros"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-4331"
            pageIdentifier="obitos"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.obitos_ajuda || 0) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.obitos_ajuda || 0
            "
            keyAjudaModalInformacao="obitos_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Óbitos',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
